import { SVGProps } from "react";

export const ChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M11.5 15.858C11.6911 16.0473 12.0097 16.0473 12.2008 15.858C12.3919 15.6686 12.3919 15.3531 12.2008 15.1637L4.99357 8.02367L12.2566 0.836293C12.4477 0.646944 12.4477 0.331363 12.2566 0.142014C12.161 0.0473394 12.0336 9.36224e-07 11.9061 9.30155e-07C11.7787 9.24085e-07 11.6513 0.0473394 11.5557 0.142014L3.5999 8.02367L11.5 15.858Z" />
  </svg>
);
